import React from 'react';
import {Document, Packer, Paragraph, TextRun, AlignmentType, TabStopPosition, TabStopType} from 'docx';
import { saveAs } from 'file-saver';

export default (reclamoData) => {
    console.log("reclamoData: ", reclamoData)
    // objeto inicial
    const claimData = {
        date: 'Thursday, April 07th, 2025',
        claimRef: reclamoData,
        uniqueCode: 'NYDT',
        bl: '247910361',
        vessel: 'MAERSK SALTORO',
        pol: 'San Antonio, Chile',
        etd: '26/12/2024',
        ata: '17/02/2025',
        claimAmount: '99,491.61 USD',
        container: 'MNBU3904978',
        voyage: '450W',
        pod: 'Nansha, China',
        eta: '30/01/2025',
        goods: 'Cherries',
        principals: 'Sociedad C&L Frut SpA',
        breakdown: {
            smv: '82,664.61 USD',
            sales: '0.00 USD',
            freightCosts: '12,532.89 USD',
            inspectionCosts: '850.00 USD',
            customsAgentCosts: '1,421.67 USD',
            destructionCosts: '2,022.44 USD',
            total: '99,491.61 USD',
        },
    };

    const generateClaimLetter = () => {
        const doc = new Document({
            styles: {
                default: {
                    document: {
                        run: {
                            font: 'Cambria',
                            color: '595959', // Negro Texto 1 Claro 35% aproximado
                        },
                    },
                },
            },
            sections: [
                {
                    properties: {
                        page: {
                            margin: { top: 720, bottom: 720, left: 720, right: 720 }, // Márgenes de 1 pulgada (720 twips)
                        },
                    },
                    children: [
                        // Fecha
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            children: [new TextRun({ text: claimData.date, italics: true, font: 'Cambria', size: 20 })],
                        }),
                        // Destinatario
                        new Paragraph({ children: [new TextRun({ text: 'Messrs.', italics: true, font: 'Cambria', size: 22 })] }),
                        new Paragraph({ children: [new TextRun({ text: 'Maersk', bold: true, italics: true, font: 'Cambria', size: 22 })] }),
                        new Paragraph({ children: [new TextRun({ text: 'Claims Department.', bold: true, italics: true, font: 'Cambria', size: 22 })] }),
                        new Paragraph({ spacing: { after: 200 } }), // Espacio después
                        // Referencia
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [new TextRun({ text: `Claim Letter Ref. N° ${claimData.claimRef}`, bold: true, font: 'Cambria', size: 24 })],
                        }),
                        new Paragraph({ spacing: { after: 200 } }),
                        // Detalles del envío
                        new Paragraph({
                            children: [
                                new TextRun(`B/L\t${claimData.bl}`),
                            ],
                        }),
                        new Paragraph({ children: [new TextRun(`VESSEL: ${claimData.vessel}`)] }),
                        new Paragraph({ children: [new TextRun(`POL: ${claimData.pol}`)] }),
                        new Paragraph({ children: [new TextRun(`ETD: ${claimData.etd}`)] }),
                        new Paragraph({ children: [new TextRun(`ATA: ${claimData.ata}`)] }),
                        new Paragraph({ children: [new TextRun(`CLAIM AMOUNT: ${claimData.claimAmount}`)] }),
                        new Paragraph({ children: [new TextRun(`CONTAINER: ${claimData.container}`)] }),
                        new Paragraph({ children: [new TextRun(`VOYAGE: ${claimData.voyage}`)] }),
                        new Paragraph({ children: [new TextRun(`POD: ${claimData.pod}`)] }),
                        new Paragraph({ children: [new TextRun(`ETA: ${claimData.eta}`)] }),
                        new Paragraph({ children: [new TextRun(`GOODS: ${claimData.goods}`)] }),
                        new Paragraph({ children: [new TextRun('VALUE PROTECT: Yes')] }),
                        new Paragraph({ children: [new TextRun('')] }), // Espacio
                        // Cuerpo de la carta
                        new Paragraph({
                            children: [
                                new TextRun(
                                    `By this means and on behalf of our principals Messrs. ${claimData.principals}, we hereby claim and request the reimbursement of ${claimData.claimAmount}. -, since the shipment was exposed to abnormal transit conditions while being transported under Maersk’s custody.`
                                ),
                            ],
                        }),
                        new Paragraph({ children: [new TextRun('')] }), // Espacio
                        new Paragraph({
                            children: [
                                new TextRun(
                                    'For analysis of this claim and reimbursement request, please use the unique code in the following exclusive access for carriers:'
                                ),
                            ],
                        }),
                        // Lista de documentos
                        ...[
                            'Bill Of Lading',
                            'Booking',
                            'Invoice',
                            'Phytosanitary Certificate',
                            'Origin Certificate',
                            'Tracking',
                            'Destruction Certificate',
                            'Shipping Instructions',
                            'Packing List',
                            'Survey Report',
                            'Captain Peter',
                            'Customs Agent Costs',
                            'Survey Invoice',
                            'Loss Calculation with SMV',
                            'Claim Notice',
                            'DUS',
                            'Letter of Authority',
                            'Assignment of Rights',
                        ].map((item, index) => new Paragraph({ children: [new TextRun(`${index + 1}. ${item}`)] })),
                        new Paragraph({ children: [new TextRun('')] }), // Espacio
                        // Desglose
                        new Paragraph({ children: [new TextRun('BREAKDOWN:')] }),
                        new Paragraph({ children: [new TextRun(`${claimData.breakdown.smv} (SMV)`)] }),
                        new Paragraph({ children: [new TextRun(`- ${claimData.breakdown.sales} (Sales)`)] }),
                        new Paragraph({ children: [new TextRun(`+ ${claimData.breakdown.freightCosts} (Freight Costs)`)] }),
                        new Paragraph({ children: [new TextRun(`+ ${claimData.breakdown.inspectionCosts} (Inspection Costs)`)] }),
                        new Paragraph({ children: [new TextRun(`+ ${claimData.breakdown.customsAgentCosts} (Customs Agent Costs)`)] }),
                        new Paragraph({ children: [new TextRun(`+ ${claimData.breakdown.destructionCosts} (Destruction Costs)`)] }),
                        new Paragraph({ children: [new TextRun(`= ${claimData.breakdown.total}`)] }),
                        new Paragraph({ children: [new TextRun('')] }), // Espacio
                        // Texto final
                        new Paragraph({
                            children: [
                                new TextRun(
                                    'This claim and reimbursement request stops any statute of limitation, producing legal interest from the date of the sinister to the verification of payment.'
                                ),
                            ],
                        }),
                        new Paragraph({
                            children: [
                                new TextRun(
                                    `RSK Group is duly acting on behalf of ${claimData.principals}, and we would appreciate your prompt attention to this matter to try to find a mutually agreed solution.`
                                ),
                            ],
                        }),
                        new Paragraph({ children: [new TextRun('')] }), // Espacio
                        new Paragraph({ children: [new TextRun('Kind regards,')] }),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then((blob) => {
            saveAs(blob, `Claim_Letter_generated_${claimData.claimRef}.docx`);
        });
    };

    return <button onClick={generateClaimLetter}>Generar Carta de Reclamo</button>;
};